<div class="setting-page">
  <div class="time-based-routing">
    <legend>Time based routing</legend>
    <div class="action-buttons">
      <arm-action-bar (addClick)="addTimeCondition()" [disableAdd]="isUnauthorized || isTBRDisabled"
                      (refreshClick)="refresh()"
                      (deleteClick)="deleteTimeConditions()" [disableDelete]="isUnauthorized || isTBRDisabled || !selection"
                      (editClick)="updateTimeCondition()" [disableEdit]="isUnauthorized || isTBRDisabled || !selection">
      </arm-action-bar>
    </div>

    <div class="tbr-table">
      <arm-table [displayedColumns]="displayedColumns"
                 (onSelection)="onSelection($event)"
                 [data]="data"
                 [isMultipleSelection]="false"
                 [isClientSide]="true"></arm-table>
    </div>
  </div>
</div>
